import React, { useEffect, useRef } from 'react';
import EducationHero from './EducationHero/EducationHero';
import AboutEducation from './AboutEducation/AboutEducation';
import EducationPortfolioPart from './EducationPortfolioPart/EducationPortfolioPart';
import EducationDetails from './EducationDetails/EducationDetails';
import WithUs from '../../Landing/WithUs/WithUs';
import Footer from '../../../Components/Footer/Footer';
import SeoHelmet from '../../../Components/SeoHelmet';

const EducationServicesLanding = () => {
  const scrollRef = useRef(null)
  useEffect(()=>{
    scrollRef.current.scrollIntoView()
  }
,[])
  return (
    <div className='overflow-hidden'>
      <div ref={scrollRef}></div>
      <SeoHelmet
        title="SunMed | Education"
        description="SunMed: One Team with All Services under one roof — media production, social
        media, design, events, and web — all flowing from a unified creative
        vision.."
        keywords="SunMed, media production, web solutions, digital marketing, education, event management"
        url="https://sunmed.com"
        image="https://sunmed.com/images/sunmed-home-og.jpg"
      />
      <EducationHero/>
      <AboutEducation/>
      <EducationPortfolioPart/>
      <EducationDetails/>
      <WithUs/>
      <Footer/>
    </div>
  );
}

export default EducationServicesLanding;
